export default __webpack_public_path__ + "assets/079e224fe7d10ad1f76b0cb1d0fa3d40.svg";